import { StripeApi, StripeCreateCheckoutSessionPOSTRequest, StripeCreateCheckoutSessionResponse } from 'microshop-api';
import { config } from './api';

const stripeApi = new StripeApi(config);

type StripeCheckoutSessionStatus = {
    status: string;
    paymentStatus: string;
};

const stripe = {
    // Required - though it may be undefined - for the same reason as the priced cart calls: the session
    // is charged with whatever option the server applies, and it stores none of its own.
    createCheckoutSession: (
        request: StripeCreateCheckoutSessionPOSTRequest & { shippingOptionId: number | undefined },
    ): Promise<StripeCreateCheckoutSessionResponse> => stripeApi.stripeCreateCheckoutSessionPOST(request),
    getCheckoutSessionStatus: async (sessionId: string): Promise<StripeCheckoutSessionStatus> => {
        const response = await fetch(
            `/stripe/microshop/checkout/getSessionStatus?sessionId=${encodeURIComponent(sessionId)}`,
            {
                headers: config.headers,
                credentials: 'same-origin',
            },
        );

        if (!response.ok) throw new Error('Unable to retrieve checkout session status');
        return response.json();
    },
    validateCheckoutSessionAmount: async (shippingOptionId: number | undefined): Promise<boolean> => {
        const query = shippingOptionId === undefined ? '' : `?shippingOptionId=${shippingOptionId}`;
        const response = await fetch(`/stripe/microshop/checkout/validateSessionAmount${query}`, {
            headers: config.headers,
            credentials: 'same-origin',
        });

        if (response.status === 409) return false;
        if (!response.ok) throw new Error('Unable to validate checkout session amount');
        return true;
    },
};

export { stripe };
